var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconQrWebsite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 2)"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "#595959",
    fill: "#FFF",
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 27,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 .5c.414 0 .79.168 1.06.44.272.27.44.646.44 1.06v4.5H.5V2c0-.414.168-.79.44-1.06C1.21.667 1.585.5 2 .5z",
    stroke: "#595959",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#595959",
    x: 2,
    y: 3,
    width: 2,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#595959",
    x: 5,
    y: 3,
    width: 2,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#595959",
    x: 8,
    y: 3,
    width: 2,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#595959",
    x: 18,
    y: 12,
    width: 10,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#595959",
    x: 18,
    y: 14,
    width: 10,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#595959",
    x: 18,
    y: 16,
    width: 10,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 19,
    width: 5,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#595959",
    cx: 9,
    cy: 17,
    r: 4.5
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#595959",
    fill: "#F2F2F2",
    d: "m12.5 10 3.5 7H9z"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#595959",
    x: 21,
    y: 21,
    width: 5,
    height: 1,
    rx: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQrWebsite);
export default __webpack_public_path__ + "static/media/icon-qr-website.b18f121b7ef2926edf7a6ac0347ef066.svg";
export { ForwardRef as ReactComponent };